// @ts-check
import moment from "moment-timezone";
import {SCREENING} from "../certification-badge/constants";
import {backgroundCheckKeyName} from "../../components/roster/rosterUserCertification.service";

/**
 * @typedef {import('../../components/roster/types.js').UserCertification} UserCertification
 */

/**
 * @typedef {Object} Certification
 * @property {string} badgeIcon
 * @property {string} certificateId
 * @property {string} certificateName
 * @property {string|null} [certificateUrl]
 * @property {string|null} [completedOn]
 * @property {string|null} [expiresOn]
 * @property {string|null} [notes]
 * @property {boolean|null} [verified]
 * @property {string|number|null} [verifiedBy]
 */

export function getCovidPolicyIcon({
  covid_vaccination_date,
  covid_exemption_approved_date,
  covid_testing_latest_date,
  timezone,
}) {
  let icon_uri = "";
  let tooltip = "";

  if (covid_vaccination_date) {
    icon_uri = "images/full-vaccinated-icon.svg";
    tooltip = "Full vaccinated against Covid-19";
  }

  if (covid_exemption_approved_date) {
    icon_uri = "images/exempt-from-vaccination-icon.svg";
    tooltip = "Medically or religiously exempt from COVID vaccination mandates";
  }

  if (covid_testing_latest_date) {
    icon_uri = "images/tested-for-covid-icon.svg";
    tooltip = `Tested negative for COVID, valid through ${moment(
      covid_testing_latest_date
    )
      .tz(timezone)
      .format("ll")}`;
  }

  return {
    icon_uri,
    tooltip,
    has_icon: !!icon_uri,
  };
}

/**
 * @param certifications {Certification[]} - array of certifications
 * @returns {UserCertification[]}
 */
export function formatCertificationIcons(certifications) {
  const certIcons = [];
  let tooltip = "";
  let icon_uri = "";
  certifications.forEach((certification) => {
    tooltip = certification.certificateName;
    icon_uri = certification.badgeIcon || "";

    if (SCREENING.DRUG.CERT_STRINGS.tooltipMapping[certification.certificateId]) {
      tooltip = "Drug screened";
    } else if (certification.certificateName.startsWith(backgroundCheckKeyName)) {
      tooltip = "Background checked";
    }

    certIcons.push({
      icon_uri,
      tooltip,
      has_icon: !!icon_uri,
    });
  });

  return certIcons;
}
